<template>
    <!-- 英语开口读绘本 -->
    <div
        v-if="(pageData.courseTypeId !== 13) && showModele && swiperData && swiperData.length"
        class="picbook-box"
    >
        <div :class="['title']">
            开口读绘本
        </div>
        <Swiper
            class="swiper"
            :autoplay="false"
            :loop="false"
            :allow-touch-move="false"
            @swiper="onSwiper"
            @transitionEnd="onTransitionEnd"
            @tap="handleClickPlayBtn"
        >
            <div class="cover">
                <img
                    v-if="showCover || !isPlayAudio"
                    src="https://i.gsxcdn.com/2274080577_ggn54um8.png"
                    class="play-btn"
                    @click.stop="handleClickPlayBtn"
                >
                <img v-if="showCover" class="cover-img" :src="hbCoverInfo.coverImageUrl" alt="">
            </div>
            <SwiperSlide
                v-for="(swiperItem, swiperIndex) in swiperData"
                :key="swiperIndex"
            >
                <div class="swiper-box">
                    <img
                        :src="swiperItem.qHbImage"
                        class="swiper-image"
                    >
                    <div class="swiper-txt">
                        <div>{{swiperItem.qHbText}}</div>
                    </div>
                </div>
            </SwiperSlide>
            <div class="pager">
                {{currentIndex + 1}}/{{total}}
            </div>
        </Swiper>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import SwiperCore, {EffectCoverflow, Navigation} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper.min.css';

SwiperCore.use([EffectCoverflow, Navigation]);

@Options({
    components: {
        Swiper,
        SwiperSlide,
    },
    mounted() {
        console.log(222222);
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        },
        showModele: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    computed: {
        hbCoverInfo() {
            const {hbCoverInfo} = this.pageData;
            return hbCoverInfo || {};
        },
        swiperData() {
            const {hbPages} = this.pageData;
            return hbPages || [];
        },
        total() {
            return this.swiperData.length;
        }
    },
    watch: {
        showModele(val) {

            /**
             * 监听showModele来处理前后台切换，因为：
             * 将speech组件的v-if放在组件内部是要处理swiper组件的渲染问题，
             * 如果v-if放在外面的话speech组件会走完整的生命周期，导致swiper组件渲染失效，会有警告(Component is missing template or render function.)【未解】
             * 因此改变策略将v-if放在speech内部，那么speech的生命周期不会重新走，那么就要特殊处理语音播放问题
             */
            if (!val) {
                this.isPlayAudio = false;
                this.currentIndex = 0;
                this.showCover = true;
                this.audioEl?.pause();
            }
        }
    },
})
export default class Speech extends Vue {
    // 轮播图当前下图片的下标
    currentIndex = 0;

    showCover = true;

    // 用户是否点击了播放按钮
    isPlayAudio = false;

    // 音频节点
    audioEl = null;

    init() {
        this.showCover = true;
        this.isPlayAudio = false;
        this.currentIndex = 0;
    }

    onSwiper(swiper) {
        console.log(swiper);
        this.swiper = swiper;
    }

    // 处理轮播图滑动
    onTransitionEnd() {
        if (this.showCover) {
            return;
        }
        this.currentIndex += 1;
        console.log('滑动了currentIndex=', this.currentIndex);
        if (this.currentIndex >= this.total) {
            this.init();
        }
        else if (this.isPlayAudio) {
            this.playSwiperTiganAudio(this.swiperData[this.currentIndex].qHbAudio);
        }
    }

    // 播放轮播图题干音频
    playSwiperTiganAudio(url, cb) {
        const audioEndFn = () => {
            console.log('audioEndFn this.currentIndex', this.currentIndex);
            // 看下是否是最后一个了
            if (this.currentIndex + 1 === this.total) {
                console.log('swiper.slideTo(0)');
                this.swiper.slideTo(0);
                console.log('swiper.slideTo(0) end');
            }
            else {
                console.log('swiper.slideNext()');
                // 播放完成翻页
                this.swiper.slideNext();
                console.log('swiper.slideNext() end');
            }
        };
        console.log('playSwiperTiganAudio url=', url);
        console.log('playSwiperTiganAudio this.currentIndex=', this.currentIndex);
        if (url) {
            url = url.replace('http://', 'https://');
            this.playAudio(url).then(() => {
                audioEndFn();
            });
        }
        else {
            audioEndFn();
        }
    }

    // 点击播放按钮
    handleClickPlayBtn() {
        this.$emit('eventBus', 'kkdhb');
        this.showCover && (this.showCover = false);
        if (this.isPlayAudio) {
            this.isPlayAudio = false;
            this.audioEl.pause();
        }
        else {
            this.isPlayAudio = true;
            // 再次播放要继续播，而不是从头播放
            this.playSwiperTiganAudio(this.swiperData[this.currentIndex].qHbAudio);
            // 捕获是否有正在播放的视频，有的话全部停掉
            const allVideos = document.querySelectorAll('.oss-work-video');
            const arr = [...allVideos];
            arr.forEach(item => {
                item.pause();
            });
        }
    }

    resetAll() {
        console.log('resetAll');
        this.init();
        this.swiper.slideTo(0);
        this.audioEl && this.audioEl.pause();
        console.log('resetAll end');
    }

    // 播放语音
    playAudio(url) {
        console.log(' ------ playAudio ------', url);
        // 播放语音
        return new Promise(resolve => {
            if (!url) {
                resolve();
            }
            if (!this.audioEl) {
                const audio = new Audio();
                audio.onabort = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onabort',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onabort ${url}`);
                };
                audio.onwaiting = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onwaiting',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onwaiting ${url}`);
                };
                this.audioEl = audio;
            }
            this.audioEl.src = url;
            this.audioEl.currentTime = 0;
            this.audioEl.load();
            this.audioEl.onended = () => {
                console.log('playAudio onended', url);
                resolve();
            };
            this.audioEl.onpause = () => {
                console.log('playAudio onpause', url);
                // resolve();
            };
            this.audioEl.onerror = error => {
                console.log(
                    JSON.stringify({
                        content: 'playAudio onerror',
                        audioUrl: url,
                        error: this.audioEl.error?.message,
                    })
                );
                console.log('playAudio onerror', url);
                console.log(this.audioEl.error?.message);
                resolve(error);
            };
            this.audioEl.play();
        });
    }
}
</script>

<style lang="scss" scoped>
.picbook-box {
    width: 9.15rem;
    padding-bottom: .96rem;
    margin-top: .8rem;
    background: #FFFFFF;
    box-shadow: 0 .05rem .21rem 0 rgba(118,118,118,.15);
    border-radius: .43rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        margin-top: -.25rem;
        margin-bottom: .64rem;
        display: flex;
        padding-top: .345rem;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 4.53rem;
        height: 1.07rem;
        background: url('https://i.gsxcdn.com/2725359897_t1e029yp.png') 0 no-repeat;
        background-size: cover;
        box-sizing: border-box;
    }

    .swiper {
        width: 8.08rem;
        height: 5.52rem;
        background: #FFFFFF;
        border-radius: .32rem;
        border: .03rem solid #ECFEF6;
        position: relative;
    }

    .cover {
        width: 8.08rem;
        height: 5.52rem;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        border-radius: .32rem;

        .play-btn {
            width: 1.39rem;
            height: 1.39rem;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .cover-img {
            width: 100%;
            height: 100%;
            border-radius: .32rem;
        }
    }

    .swiper-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height: 100%;

        .swiper-image {
            object-fit: contain;
            width: 8.08rem;
            height: 4.43rem;
        }

        .swiper-txt {
            max-width: 6.8rem;
            height: calc(100% - 4.43rem);
            display: flex;
            justify-content: center;
            align-items: center;

            div {
                word-wrap: break-word;
                font-weight: 600;
                font-size: .32rem;
                color: #333333;
            }
        }
    }

    .pager {
        width: 1.07rem;
        height: .53rem;
        background: rgba(0, 0, 0, .43);
        border-radius: .27rem;
        font-weight: 400;
        font-size: .32rem;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: .16rem;
        top: 3.6rem;
        z-index: 2;
    }
}
</style>
